import React from 'react';
import { Phone, Clock, ArrowUpRight } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
export function UrgencyBar() {
  const {
    openUpload
  } = useDrawers();
  return <div className="bg-ink text-cream text-sm" data-id="element-419">
      <div className="max-w-7xl mx-auto px-5 md:px-6 py-2.5 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-1.5 sm:gap-4 text-center" data-id="element-420">
        <p className="flex items-center gap-2 text-cream/85" data-id="element-421">
          <Clock className="w-4 h-4 text-accent-light shrink-0" data-id="element-422" />
          Auction or signing deadline coming up? Add the date to your enquiry
          and the team will assess the urgency.
        </p>
        <div className="flex items-center gap-4 shrink-0" data-id="element-423">
          <a href="tel:+61386172600" className="hidden sm:flex items-center gap-1.5 font-semibold hover:text-accent-light transition-colors" data-id="element-424">
            <Phone className="w-3.5 h-3.5" data-id="element-425" />
            (03) 8617 2600
          </a>
          <button onClick={openUpload} className="inline-flex items-center gap-1 font-semibold text-accent-light hover:text-white transition-colors" data-id="element-426">
            Upload a contract
            <ArrowUpRight className="w-3.5 h-3.5" data-id="element-427" />
          </button>
        </div>
      </div>
    </div>;
}